import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
const DashboardLayout: React.FC = () => {
  return <div className="flex min-h-screen bg-gray-100" data-id="element-280">
      <Sidebar data-id="element-281" />
      <div className="flex-1 p-6 lg:p-8" data-id="element-282">
        <Outlet data-id="element-283" />
      </div>
    </div>;
};
export default DashboardLayout;